import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { ActionIcon, polymorphicFactory, useProps } from "@coveord/plasma-mantine";
import { useTopBarContext } from "./TopBarContext.js";
var defaultProps = {
    size: "md"
};
export var TopBarAction = polymorphicFactory(function(_props, ref) {
    var ctx = useTopBarContext();
    var _ref = useProps("TopBarAction", defaultProps, _props), children = _ref.children, others = _object_without_properties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(ActionIcon.Quaternary, _object_spread_props(_object_spread({
        ref: ref
    }, ctx.getStyles("action"), others), {
        children: children
    }));
});

//# sourceMappingURL=TopBarAction.js.map